<app-progress-spinner [loading]="!galleryReady"></app-progress-spinner>
<uilab-mat-sidenav-container>
  <uilab-mat-sidenav
    #sidenav
    fixedInViewport="true"
    mode="over"
    position="end"
    class="side"
    [fixedTopGap]="gap"
    >
    <section id="details" class="uilabContainer">
      <header class="uilabContainer--header">
        <div class="uilabContainer--header__identity">
          <span
            [innerHtml]="selectedIcon.svg | safeHtml"
            class="uilab-icon large"
          ></span>
          <h6>{{
            selectedIcon.title != '' ? selectedIcon.title : '---'
          }}</h6>
        </div>
        <uilab-icon-button (click)="sidenav.close()">
          <uilab-icon slot="icon" icon="action--close"></uilab-icon>
        </uilab-icon-button>
      </header>

      <section class="uilabContainer--content">
        <app-icon-details
          [icon]="selectedIcon"
          [style]="filterArgs.iconstyle"
        ></app-icon-details>
      </section>
    </section>
  </uilab-mat-sidenav>

  <uilab-mat-sidenav-content class="content">
    <div class="iconGallery--header">
      <div class="iconGallery--count">{{ icons.length }} icons shown</div>
      <div class="iconGallery--version"
        >Version {{ iconService.version }}</div
        >
      </div>

      <div>
        <div class="icons-content">
          <app-icon-filter
            [args]="filterArgs"
            (onFilterChange)="FilterChange()"
          ></app-icon-filter>

          @if (galleryReady) {
            @if (!error) {
              @for (c of categories; track c) {
                <div
                  class="iconGallery__show-labels"
                  >
                  <h2 class="iconGallery--section-title">{{
                    c.category
                  }}</h2>
                  <div class="iconGallery--icon-list">
                    @for (i of icons; track i) {
                      @if (i.category === c.category) {
                        <div
                          class="iconGallery--icon icon"
                          (click)="select(i)"
                          >
                          <span
                            class="default"
                            [innerHtml]="i.svg | safeHtml"
                          ></span>
                          <span class="iconGallery--icon-label">{{
                            i.title
                          }}</span>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
              @if (icons.length == 0) {
                <div>
                  <div class="notfound">
                    No icons found matching pattern "{{
                    filterArgs.filter
                    }}"
                  </div>
                </div>
              }
            } @else {
              <app-error [error]="errorMsg"></app-error>
            }
          } @else {
            <app-icon-gallery-blockframe></app-icon-gallery-blockframe>
          }
        </div>
        <div class="uilabContainer--footer"></div>
      </div>
    </uilab-mat-sidenav-content>
  </uilab-mat-sidenav-container>
